// AGC: Mock data for financial dashboard
// AGC: Visual Refresh - Icons now use Lucide icon names instead of emoji
import { DashboardData, FinancialSummary, Activity, QuickAction } from '../types'

/**
 * AGC: Mock financial summary data
 */
export const mockFinancialSummary: FinancialSummary[] = [
  {
    type: 'revenue',
    amount: 850000,
    change: 12.5,
    trend: 'up',
    sparklineData: [65, 72, 68, 75, 80, 78, 85],
  },
  {
    type: 'expenses',
    amount: 425000,
    change: 8.3,
    trend: 'up',
    sparklineData: [40, 42, 45, 43, 48, 46, 50],
  },
  {
    type: 'profit',
    amount: 425000,
    change: 15.8,
    trend: 'up',
    sparklineData: [25, 30, 23, 32, 32, 32, 35],
  },
]

/**
 * AGC: Mock quick actions
 * AGC: Visual Refresh - Using Lucide icon names
 */
export const mockQuickActions: QuickAction[] = [
  {
    id: 'new-plot',
    label: 'dashboard.shortcutNewLot',
    iconName: 'MapPin',
    screen: 'novo-lote',
  },
  {
    id: 'new-task',
    label: 'dashboard.shortcutNewTask',
    iconName: 'ListTodo',
    screen: 'new-task',
  },
  {
    id: 'finances',
    label: 'dashboard.shortcutNewFinance',
    iconName: 'DollarSign',
    screen: 'finances',
  },
  {
    id: 'inventory',
    label: 'dashboard.shortcutNewInventory',
    iconName: 'Package',
    screen: 'inputs',
  },
]

/**
 * AGC: Mock recent activities
 * AGC: Visual Refresh - Using Lucide icon names
 */
export const mockActivities: Activity[] = [
  {
    id: 'act-1',
    type: 'task',
    title: 'Irrigação iniciada no Talhão Sul',
    description: 'Sistema de irrigação ativado por João Silva',
    iconName: 'Droplets',
    timestamp: new Date(Date.now() - 2 * 60 * 60 * 1000).toISOString(),
    fieldId: 'field-1',
    plotId: 'plot-3',
    taskId: 'task-6',
  },
  {
    id: 'act-2',
    type: 'weather',
    title: 'Alerta de chuva para amanhã',
    description: '75% de chance de precipitação',
    iconName: 'CloudRain',
    timestamp: new Date(Date.now() - 4 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'act-3',
    type: 'crop',
    title: 'Monitoramento de pragas atualizado',
    description: 'Baixa incidência detectada na Área Leste',
    iconName: 'ScanLine',
    timestamp: new Date(Date.now() - 8 * 60 * 60 * 1000).toISOString(),
    fieldId: 'field-2',
    taskId: 'task-2',
  },
  {
    id: 'act-4',
    type: 'financial',
    title: 'Pagamento de insumos realizado',
    description: 'R$ 45.000 em fertilizantes',
    iconName: 'Wallet',
    timestamp: new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString(),
  },
  {
    id: 'act-5',
    type: 'task',
    title: 'Manutenção do pivô concluída',
    description: '45 gotejadores substituídos',
    iconName: 'Wrench',
    timestamp: new Date(Date.now() - 3 * 24 * 60 * 60 * 1000).toISOString(),
    fieldId: 'field-3',
    plotId: 'plot-6',
    taskId: 'task-3',
  },
  {
    id: 'act-6',
    type: 'crop',
    title: 'Estágio de floração detectado',
    description: 'Milho no Talhão Norte B',
    iconName: 'Flower2',
    timestamp: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000).toISOString(),
    fieldId: 'field-1',
    plotId: 'plot-2',
  },
]

/**
 * AGC: Get greeting i18n key based on time of day
 * AGC: Returns a translation key to be passed through t() at the call site
 */
export const getGreeting = (): string => {
  const hour = new Date().getHours()
  if (hour < 12) return 'dashboard.greetingMorning'
  if (hour < 18) return 'dashboard.greetingAfternoon'
  return 'dashboard.greetingEvening'
}

/**
 * AGC: Mock dashboard data
 */
export const mockDashboardData: DashboardData = {
  greeting: getGreeting(),
  userName: 'Carlos',
  userAvatar: 'https://randomuser.me/api/portraits/men/75.jpg',
  financialSummary: mockFinancialSummary,
  quickActions: mockQuickActions,
  recentActivities: mockActivities,
  alerts: [
    {
      id: 'alert-1',
      type: 'warning',
      title: 'Déficit Hídrico',
      message: 'Talhão Sul apresenta sinais de estresse hídrico',
      actionLabel: 'Ver Detalhes',
      actionScreen: 'field-detail',
    },
  ],
}
